import React from 'react';
import { TextField, SelectField } from 'react-admin';
import PropTypes from 'prop-types';
import EjectedDatagrid from '../../../components/ejected/Datagrid';
import EjectedSelectField from '../../../components/ejected/SelectField';
import { COMPANY_STATUS_NEW } from '../../../common';
import TextFieldWithPrice from '../../../components/TextFieldWithPrice';
import TextFieldWithDate from '../../../components/TextFieldWithDate';

const Datagrid = ({
  create, edit, total, companies, callcenters, roles, city, ...rest
}) => (
  <EjectedDatagrid
    currentSort={{ order: 'ASC', field: 'name' }}
    create={create}
    edit={edit}
    {...rest}
  >
    <TextField source="name" label="Название" customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }} />
    <SelectField source="cityId" label="Город" customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }} choices={city} optionText='title' />
    <TextField source="address_details" label="Адрес" customstyles={{ width: '120px', backgroundColor: '#2c9bc3' }} />
    <TextField source="adminName" label="Имя рук." customstyles={{ width: '90px', backgroundColor: '#2c9bc3' }} />
    <TextField source="adminEmail" label="Email рук." customstyles={{ width: '150px', backgroundColor: '#2c9bc3' }} />
    <TextField source="adminPhone" label="Тел. рук." customstyles={{ width: '90px', backgroundColor: '#2c9bc3' }} />
    <TextField source="usersCount" label="Users" customstyles={{ width: '90px', backgroundColor: '#2c9bc3' }} />
    <TextFieldWithPrice source="operator_fee" label="% Опер." customstyles={{ width: '70px', backgroundColor: '#2c9bc3' }} />
    <TextFieldWithPrice source="leadCost" label="Цена лида" customstyles={{ width: '70px', backgroundColor: '#2c9bc3' }} />
    <TextFieldWithDate source="_createdAt" isDate showYear label="Дата рег." customstyles={{ textAlign: 'left', width: '100px', backgroundColor: '#2c9bc3' }} />
    <EjectedSelectField
      source="statusnew"
      label="Статус"
      choices={COMPANY_STATUS_NEW}
      optionText="shortName"
      customstyles={{
        background: '#cd9b4a',
        width: '60px',
      }}
    />
  </EjectedDatagrid>
);

Datagrid.defaultProps = {
  edit: null,
  create: null,
  companies: [],
  callcenters: [],
  roles: [],
  city: []
};

Datagrid.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
  companies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  city: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })),
  callcenters: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  roles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }))
};

export default Datagrid;



// WEBPACK FOOTER //
// ./src/pages/callcenter/company/Datagrid.js